class VwHemsireIsListesiDTO {
    id: number = null;
    tarih: string = null;
    saat: string = null;
    hastaAdiSoyadi: string = "";
    ilacAdi: string = "";
    kullanimSekli: string = "";
    dozBirimi: number = null;
    dozMiktar: number = null;
    islem: string = "";
    planlananDoz: number = null;
    uygulananDoz: number = null;
    drNotlari: string = "";
    uygulamaTarihi: number = null;
    uygulamaSaati: string = "";
    doktorAdi: string = "";
    muracaatId: number = null;
    servisId: number = null;
    servisAdi: string = "";
    dozAciklama: string = "";
    periyodId: number = null;
    uygulamaDurumu: number = null;
    periyodSure: number = null;
}

export default VwHemsireIsListesiDTO;
